export default __webpack_public_path__ + "static/media/tapir.bc49dd3a.jpg";